import { Routes, Route } from "react-router-dom";
import Nominations from "./Nominations";

const index = () => {
	return (
		<Routes>
			<Route index element={<Nominations />} />
		</Routes>
	);
};

export default index;
